var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef, useEffect, useState } from "react";
import styled from "styled-components";
import { usePopper } from "react-popper";
import ClickAwayListener from "../ClickAwayListener/ClickAwayListener";
import { useTheme } from "../ThemeProvider/ThemeProvider";
var StyledMenuContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: ", ";\n  min-width: ", ";\n  border: 1px solid #c4c4c4;\n  border-radius: 0.5rem;\n  padding: 0.5rem 0;\n  background-color: ", "\n  color: ", ";\n  border:", ";\n"], ["\n  display: ", ";\n  min-width: ", ";\n  border: 1px solid #c4c4c4;\n  border-radius: 0.5rem;\n  padding: 0.5rem 0;\n  background-color: ", "\n  color: ", ";\n  border:", ";\n"])), function (props) { return (props.$open ? "block" : "none"); }, function (props) { return props.$minWidth; }, function (props) { var _a; return (_a = props.$colorPalette) === null || _a === void 0 ? void 0 : _a.primary.grayScale[1]; }, function (props) { var _a; return (_a = props.$colorPalette) === null || _a === void 0 ? void 0 : _a.primary.grayScale[11]; }, function (props) { var _a; return "1px solid ".concat((_a = props.$colorPalette) === null || _a === void 0 ? void 0 : _a.primary.grayScale[6]); });
var StyledMenu = styled.ul(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  box-sizing: border-box;\n  width: 100%;\n  list-style-type: none;\n  cursor: pointer;\n  padding: 0;\n  margin: 0;\n  user-select: none;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  box-sizing: border-box;\n  width: 100%;\n  list-style-type: none;\n  cursor: pointer;\n  padding: 0;\n  margin: 0;\n  user-select: none;\n"])));
var Menu = forwardRef(function (_a, ref) {
    var _b, _c;
    var children = _a.children, style = _a.style, popperStyles = _a.popperStyles, _d = _a.open, open = _d === void 0 ? false : _d, _e = _a.minWidth, minWidth = _e === void 0 ? "none" : _e, anchorElement = _a.anchorElement, _f = _a.hideOnOutsideClick, hideOnOutsideClick = _f === void 0 ? true : _f, 
    // Events
    onClick = _a.onClick, onClose = _a.onClose;
    var _g = useState(open !== null && open !== void 0 ? open : false), isOpen = _g[0], setIsOpen = _g[1];
    var _h = useState(null), popperElement = _h[0], setPopperElement = _h[1];
    var colorPalette = useTheme().theme.colorPalette;
    useEffect(function () {
        setIsOpen(open !== null && open !== void 0 ? open : false);
    }, [open]);
    var _j = usePopper(anchorElement, popperElement, {
        placement: (_b = (popperStyles && popperStyles.placement)) !== null && _b !== void 0 ? _b : "bottom-start",
        modifiers: (_c = (popperStyles && popperStyles.modifiers)) !== null && _c !== void 0 ? _c : [
            {
                name: "offset",
                options: {
                    offset: [0, 2.5],
                },
            },
        ],
    }), styles = _j.styles, attributes = _j.attributes;
    var _onClick = function (e, _a) {
        var title = _a.title, value = _a.value;
        onClick && onClick(e, { title: title, value: value });
    };
    var _onClose = function (e) {
        setIsOpen(false);
        onClose && onClose(e);
    };
    if (!children)
        return null;
    if (Array.isArray(children) && children.length === 0)
        return null;
    var MenuElement = (_jsx(StyledMenuContainer, __assign({ ref: setPopperElement, "$open": isOpen, "$minWidth": minWidth, style: __assign(__assign({}, styles.popper), style) }, attributes.popper, { children: _jsx(StyledMenu, { children: React.Children.map(children, function (child, index) {
                var _a;
                if (!child)
                    return child;
                if (!React.isValidElement(child))
                    return child;
                return React.cloneElement(child, {
                    key: (_a = child.props.index) !== null && _a !== void 0 ? _a : index,
                    onClick: _onClick,
                });
            }) }) })));
    if (hideOnOutsideClick) {
        return (_jsx(ClickAwayListener, __assign({ onClickAway: _onClose }, { children: MenuElement })));
    }
    return MenuElement;
});
export default Menu;
var templateObject_1, templateObject_2;
